const faqsPoints=[
    {
      title: 'Credit Cards and Debit cards',
      description: 'We accept all International and local cards, including Master cards and Visa Cards. Cards must be enabled for recurring e-commerce transactions to work with DelveInsight.',
    },
    {
      title: 'PayPal',
      description: 'If you have a PayPal account, you can also use it as a payment option',
    },
    {
      title: 'Wire Transfer',
      description: 'You can also avail the facility of electronic money transfer from one account to other through SWIFT or others.',
    },
    {
      title: 'Cash',
      description: 'We do not accept cash as a payment method.',
    },
  
  ]
  
const faqsList = [
    {
      title: 'How do I know what categories of reports you sell?',
      description: 'To find a report of your interest or for just browsing purposes, you can have a walk-through of our website. There, you can find all of our reports categorized under Therapy Areas and Report Types. You can browse them all seamlessly. You can also make use of our search tab for a specific report.',
    },
    {
      title: 'Can I have access to the samples of the report before buying?',
      description: 'Yes. While browsing through any report of your interest, you will find an option to request sample pages, which provide a brief overview of what the report contains. You will be required to fill out a form, and our business team will mail you the sample pages upon receiving your request.',
    },
    {
      title: 'What do I do if I have a query for a specific report I need to purchase?',
      description: 'In case of any query or doubt, you can drop us an email at info@delveinsight.com, which you can find at the bottom of every page, or you can also fill out a query form through our Contact Us section.',
    },
    {
      title: 'When can I receive my order?',
      description: 'Our Business team will inform you of the timeline and associated queries post-finalization of the deliverables. We try our best to dispatch the electronic copy of your order within one hour. However, due to different time zones, there can be a minor delay in delivering the reports. We assure you the maximum delay will never exceed the time duration of 24 hours.',
    },
    {
      title: 'Can I cancel once I have placed a request or get a refund in case, I change my mind?',
      description: 'No. We are afraid DelveInsight provides no such provision for cancelling or refunding once the payment has been made. We, therefore, advise you to be extra cautious while opting for any purchase. For more information, you can go through our Terms and Conditions listed at the bottom of every page.',
    },
    {
      title: 'What if the report that I am looking for is not listed in the company’s report directory?',
      description: 'DelveInsight offers an extensive database of reports of different categories. In case the report you are looking for is not in the listed category, we suggest you connect with us to explain your requirements around the topic. We will do a feasibility check and then publish a custom report to suit your requirements.',
    },
    {
        title: 'How can I pay for Reports?',
        description:<>
            <ul>
                {faqsPoints.map((item,index)=> (
                <div key={index}>
                    <h3 className="text-lg font-semibold" key={index}>
                        <i className={index ===3 ? 'fa fa-times pr-3 text-red-600' : 'fa fa-check pr-3 text-green-600'}></i>
                        {item?.title} 
                    </h3>
                    <li className="pl-8 py-2">
                        {item?.description}
                    </li>
                </div>
                ))}
            </ul>
        </>
    },
    {
      title: 'When can I expect a response to my query?',
      description: 'Our support team prioritizes client’s needs the most. Typically, your query will be solved within 4-6 hours business hours. We assign one analyst per customer for live support for the client’s satisfaction.',
    },
    {
      title: 'Will I receive an Invoice for my transaction?',
      description: 'Yes. Once the order is placed, and we receive the amount of payment, we will email you a copy of the invoice without any delay.',
    },
    {
      title: 'Can I reprint or distribute DelveInsight’s reports?',
      description: 'The client is at liberty to use the Reports for personal and business purposes. However, we do not authorize the use of our content in any way for promotional, commercial, sales, or marketing purposes.',
    },
    // Add more FAQ items here
];

export {
    faqsList,
}